const getters = {
  productsCount(state) {
    return state.size;
  },
  shipments(state) {
    return state.shipmentPositions;
  },
  configuratorsList(state) {
    return state.configuratorPositions;
  },
  voucherValidationResult(state) {
    return state.voucherValidationResult;
  },
  productsCosts(state) {
    if (state.promotionResult) {
      return state.promotionResult.subtotal;
    }
  },
  orderDiscount(state) {
    if (state.promotionResult
      && state.promotionResult.basketDiscountInfo) {
      return state.promotionResult.basketDiscountInfo.discount;
    }
  },
  orderShippingCosts(state) {
    if (state.promotionResult) {
      return state.promotionResult.deliveryResult.deliveryCost;
    }
  },
  orderVat(state) {
    if (state.promotionResult) {
      return state.promotionResult.vat;
    }
  },
  orderTotalCosts(state) {
    if (state.promotionResult) {
      return state.promotionResult.total;
    }
  },
  orderTotalVat(state) {
    if (state.promotionResult) {
      return state.promotionResult.totalVat;
    }
  },
  orderTotalCostsGross(state) {
    if (state.promotionResult) {
      return state.promotionResult.totalGross;
    }
  },
  maxPositionQuantity(state) {
    return state.maxPositionQuantity;
  },
  taxInfoUrl(state) {
    return state.taxInfoUrl;
  },
  freeItemsActions(state) {
    return state.freeItemsActions;
  },
  specialPriceActions(state) {
    return state.specialPriceActions;
  },
  // To be honest I don't know what this is...
  informativeBenefitInfos(state) {
    return state.informativeBenefitInfos;
  }
};

export default getters;
